import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Button, type ButtonVariants } from '@/components/ui/button';
    import { DialogClose, DialogFooter } from '@/components/ui/dialog';
    import { cn } from '@/lib/utils';
    import { computed } from 'vue';
    import { useI18n } from 'vue-i18n';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'DialogFooterForm',
  props: {
    form: {},
    type: {},
    class: {},
    submitText: {},
    submitVariant: { default: 'default' }
  },
  emits: ['close'],
  setup(__props: any, { emit: __emit }) {

    const { t } = useI18n();

    const props = __props;

    const emit = __emit;

    const submitText = computed(() => {
        return t(props.submitText || `forms.${props.type}`);
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DialogFooter), {
    class: _normalizeClass(_unref(cn)('gap-2 border-t sm:justify-center', props.class))
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default"),
      _createVNode(_unref(DialogClose), { "as-child": "" }, {
        default: _withCtx(() => [
          _createVNode(_unref(Button), {
            variant: "outline",
            size: "sm",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('forms.cancel')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(Button), {
        disabled: _ctx.form.processing,
        loading: _ctx.form.processing,
        size: "sm",
        variant: _ctx.submitVariant
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(submitText.value), 1)
        ]),
        _: 1
      }, 8, ["disabled", "loading", "variant"])
    ]),
    _: 3
  }, 8, ["class"]))
}
}

})